import { createContext, useContext } from 'react';

import { type FloatingContext } from '@floating-ui/react';

import { LAYOUTS } from 'bundles/ai-coach-platform/components/patterns/popover/constants';
import { type Layout } from 'bundles/ai-coach-platform/components/patterns/popover/types';

export type QuickAccessContextType = {
  layout: Layout;
  context: FloatingContext | undefined;
  floatingProps: Record<string, unknown>;
  referenceProps: Record<string, unknown>;
};

export const QuickAccessContext = createContext<QuickAccessContextType>({
  layout: LAYOUTS.DROPDOWN,
  context: undefined,
  floatingProps: {},
  referenceProps: {},
});

export const useQuickAccessContext = () => useContext(QuickAccessContext);
